<template>
  <fragment>
    <div>
      <div class="wraper">
        <div class="container-fluid mycontainer-fluid">
          <slot name="header"></slot>
          <div class="row myrow">
            <div class="col-xs-12 mycol header-title header-title--mc">
              <div class="col-xs-12 mycol header-title--container">
                <div class="h-t-name pull-left" v-if="ea">
                  Вопросы на {{ typeSovetName }} №
                  {{ ea.UF_NUMBER }} от
                  {{ ea.UF_DATE_SOVET }}
                </div>
                <div class="pull-right">
                  <div class="button-flex-container">
                    <p v-if="typeSovetCode == 'es'">
                      <a
                        :href="
                          'https://finereport.frprf.ru/decision/view/report?viewlet=/FRP/Reports/Замечания_ЭС.cpt&exp_id=' +
                            ea.ID
                        "
                        class="project-filter__butt-btn butt-new-style stl-w-full butt-new-style-small "
                        style="text-decoration: none; color: #FFFFFF"
                        target="_blank"
                      >
                        Замечания ЭС
                      </a>
                    </p>

                    <p v-if="ea.UF_DIRECTUM_LINK_NO_TAG">
                      <a
                        :href="ea.UF_DIRECTUM_LINK_NO_TAG"
                        class="project-filter__butt-btn butt-new-style stl-w-full butt-new-style-small "
                        style="text-decoration: none; color: #FFFFFF"
                        target="_blank"
                      >
                        Протокол в Directum
                      </a>
                    </p>

                    <p v-if="experts_projects.IS_VIEW_BUTTON_EXPERTISE">
                      <a
                        :href="
                          'https://rex.frprf.ru/expertises/' + listConfig.id
                        "
                        target="_blank"
                        class="project-filter__butt-btn butt-new-style stl-w-full butt-new-style-small "
                        style="text-decoration: none; color: #FFFFFF"
                      >
                        Результаты экспертиз
                      </a>
                    </p>
                    <p
                      v-if="experts_projects.IS_VIEW_BUTTON_ARHIVR_ALL"
                      @click="getArchiveAll()"
                    >
                      <a
                        href="javascript:void(0)"
                        class="project-filter__butt-btn butt-new-style stl-w-full butt-new-style-small "
                        style="text-decoration: none; color: #FFFFFF"
                      >
                        Скачать все документы
                      </a>
                    </p>

                    <p
                      v-if="
                        isAdminRights && experts_projects.IS_VIEW_BUTTON_VOTE
                      "
                    >
                      <router-link
                        :to="{
                          name: 'ExpertsQuestions',
                          params: {
                            id: listConfig.id
                          }
                        }"
                        class="project-filter__butt-btn butt-new-style stl-w-full butt-new-style-small"
                        style="text-decoration: none; color: #FFFFFF"
                      >
                        Перейти к текущему заседанию
                      </router-link>
                    </p>
                    <p>
                      <a
                        href="javascript:void(0)"
                        @click="getLinkReport2"
                        class="project-filter__butt-btn butt-new-style stl-w-full butt-new-style-small "
                        style="text-decoration: none; color: #FFFFFF"
                        target="_blank"
                      >
                        Отчет по поручениям
                      </a>
                    </p>
                    <p>
                      <a
                        href="javascript:void(0)"
                        class="project-filter__butt-btn butt-new-style stl-w-full butt-new-style-small "
                        style="text-decoration: none; color: #FFFFFF"
                        @click="getLinkReport"
                      >
                        Генерация повестки
                      </a>
                    </p>
                    <!--<p
                    class="h-t-status-link"
                    style="padding-right: 40px;padding-top: 5px;float: left"
                  >
                    <a
                      title="Выгрузить реестр проектов"
                      @click="getLinkProjects"
                      class="xls"
                    ></a>
                  </p>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mycontainer-fluid content content_table">
          <div class="wrapper-header">
            <form v-on:submit.prevent="fetchProjects">
              <div class="row myrow project-filter filter-wrapper-stl">
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <select
                    id="filter_type_question"
                    class="filter-select-stl"
                    v-model="filter.type_question"
                  >
                    <option value="" disabled selected>Тип вопроса</option>
                    <option
                      v-for="item in directory.sp_question_expert_sovet_type"
                      v-bind:value="item.ID"
                      v-bind:key="item.ID"
                      v-text="item.NAME"
                    ></option>
                  </select>
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <input
                    id="filter_org_name"
                    type="text"
                    class="filter-input-stl"
                    v-model="filter.org_name"
                    placeholder="Организация"
                  />
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <input
                    id="filter_number"
                    type="text"
                    class="filter-input-stl"
                    v-model="filter.number"
                    placeholder="Номер проекта"
                  />
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <!--<select
                    id="filter_program"
                    class="filter-select-stl"
                    v-model="filter.program"
                  >
                    <option value="" disabled selected>Программа</option>
                    <option
                      v-for="item in DProgramFinSupport"
                      v-bind:value="item.ID"
                      v-bind:key="item.ID"
                      v-text="item.NAME"
                    ></option>
                  </select>-->

                  <Multiselect
                    label="NAME"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="filter.program"
                    :options="programList"
                    :multiple="true"
                    placeholder="Программа"
                  >
                    <span slot="noOptions">Программа не найдена</span>
                    <span slot="noResult">Программа не найдена</span>
                  </Multiselect>
                </div>
                <!--<div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <input
                    id="filter_name"
                    type="text"
                    class="filter-input-stl"
                    v-model="filter.name"
                    placeholder="Название проекта"
                  />
                </div>-->
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <!--<select
                    id="filter_status"
                    class="filter-select-stl"
                    v-model="filter.status"
                  >
                    <option value="" disabled selected>Статус проекта</option>
                    <option
                      v-for="item in directory.status"
                      v-if="
                        (currentUser.ACTIVE_ROLE_CODE === 'manager_zle' &&
                          item.CODE !== 'complex_expertise') ||
                          currentUser.ACTIVE_ROLE_CODE !== 'manager_zle'
                      "
                      v-bind:value="item.ID"
                      v-bind:key="item.ID"
                      v-text="item.NAME"
                    ></option>
                  </select>-->

                  <Multiselect
                    label="NAME"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="filter.status"
                    :options="statusList"
                    :multiple="true"
                    placeholder="Статус проекта"
                  >
                    <span slot="noOptions">Статус проекта не найден</span>
                    <span slot="noResult">Статус проекта не найден</span>
                  </Multiselect>
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <select
                    id="filter_type_making"
                    class="filter-select-stl"
                    v-model="filter.type_making"
                  >
                    <option value="" disabled selected>Тип вынесения</option>
                    <option
                      v-for="item in directory.type_making"
                      v-bind:value="item.ID"
                      v-bind:key="item.ID"
                      v-text="item.NAME"
                    ></option>
                  </select>
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <select
                    id="filter_type_question"
                    class="filter-select-stl"
                    v-model="filter.is_done_question"
                  >
                    <option value="" disabled selected
                    >Готовность вопроса
                    </option>
                    <option value="1">Готов</option>
                    <option value="0">Не готов</option>
                  </select>
                </div>

                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <Multiselect
                    label="FIO"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="filter.UF_SPEAKER_ID"
                    :options="speakerList"
                    :multiple="true"
                    placeholder="Докладчик"
                  >
                    <span slot="noOptions">Докладчик не найден</span>
                    <span slot="noResult">Докладчик не найден</span>
                  </Multiselect>
                </div>

                <div class="stl-df-ac" style="width: 394px;">
                  <div
                    class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                  >
                    <button
                      class="project-filter__butt-btn butt-new-style butt-new-style-reset stl-w-full"
                      v-on:click="clearFilter"
                      type="button"
                    >
                      СБРОС
                    </button>
                  </div>
                  <div
                    class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                  >
                    <button
                      class="project-filter__butt-btn butt-new-style stl-w-full"
                      type="submit"
                      v-on:click="fetchProjects"
                    >
                      Применить
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="table-responsive container-stl" v-if="!isEAsLoading">
            <table class="table table-hover table-striped table-new-style">
              <thead>
              <tr>
                <th></th>
                <th class="text-nowrap">
                  № п/п
                  <a
                    v-on:click="setOrder('UF_SORT')"
                    class="sort"
                    v-bind:class="{
                        desc: sortColumn === 'UF_SORT' && sortOrder === 'DESC'
                      }"
                  ></a>
                </th>
                <th class="text-nowrap" v-if="typeSovetCode !== 'rgc'">
                  № проекта
                  <a
                    href="#"
                    v-on:click="setOrder('PROJECT_UF_NUMBER')"
                    class="sort"
                    v-bind:class="{
                        desc:
                          sortColumn === 'PROJECT_UF_NUMBER' &&
                          sortOrder === 'DESC'
                      }"
                  ></a>
                </th>
                <th class="text-nowrap" v-if="typeSovetCode !== 'rgc'">
                  Название организации
                  <a
                    href="#"
                    v-on:click="setOrder('UF_COMPANY_ID')"
                    class="sort"
                    v-bind:class="{
                        desc:
                          sortColumn === 'UF_COMPANY_ID' && sortOrder === 'DESC'
                      }"
                  ></a>
                </th>
                <th class="text-nowrap" v-if="typeSovetCode !== 'rgc'">
                  Программа
                  <a
                    v-on:click="setOrder('UF_SUPPORT_PROG_ID')"
                    class="sort"
                    v-bind:class="{
                        desc:
                          sortColumn === 'UF_SUPPORT_PROG_ID' &&
                          sortOrder === 'DESC'
                      }"
                  ></a>
                </th>
                <th class="text-nowrap">
                  Вопрос
                  <a
                    v-on:click="setOrder('UF_NAME')"
                    class="sort"
                    v-bind:class="{
                        desc: sortColumn === 'UF_NAME' && sortOrder === 'DESC'
                      }"
                  ></a>
                </th>
                <th class="text-nowrap">
                  Тип вопроса
                  <a
                    v-on:click="setOrder('UF_TYPE_QUESTION')"
                    class="sort"
                    v-bind:class="{
                        desc:
                          sortColumn === 'UF_TYPE_QUESTION' &&
                          sortOrder === 'DESC'
                      }"
                  ></a>
                </th>
                <!--<th
            class="text-nowrap"
            v-if="
              this.currentUser.ACTIVE_ROLE_CODE === 'manager3' ||
                this.currentUser.ACTIVE_ROLE_CODE === 'manager2' ||
                this.currentUser.ACTIVE_ROLE_CODE === 'admin'
            "
          >
            Порядок рассмотрения
            <a
              v-on:click="setOrder('UF_SORT')"
              class="sort"
              v-bind:class="{
                desc: sortColumn === 'UF_SORT' && sortOrder === 'DESC'
              }"
            ></a>
          </th>
          <th class="text-nowrap">
            Тип вынесения
            <a
              v-on:click="setOrder('UF_TYPE_MAKING')"
              class="sort"
              v-bind:class="{
                desc:
                  sortColumn === 'UF_TYPE_MAKING' &&
                  sortOrder === 'DESC'
              }"
            ></a>
          </th>-->
                <th class="text-nowrap" v-if="typeSovetCode !== 'rgc'">
                  Статус заявки / договора
                  <a
                    v-on:click="setOrder('UF_STATUS_ID')"
                    class="sort"
                    v-bind:class="{
                        desc:
                          sortColumn === 'UF_STATUS_ID' && sortOrder === 'DESC'
                      }"
                  ></a>
                </th>
                <th class="text-nowrap">
                  Докладчик
                  <a
                    v-on:click="setOrder('UF_SPEAKER_ID')"
                    class="sort"
                    v-bind:class="{
                        desc:
                          sortColumn === 'UF_SPEAKER_ID' && sortOrder === 'DESC'
                      }"
                  ></a>
                </th>
                <th class="text-nowrap" v-if="typeSovetCode !== 'rgc'">
                  Сумма займа, тыс. руб
                  <a
                    v-on:click="setOrder('UF_SUM_REQUEST')"
                    class="sort"
                    v-bind:class="{
                        desc:
                          sortColumn === 'UF_SUM_REQUEST' &&
                          sortOrder === 'DESC'
                      }"
                  ></a>
                </th>
                <th class="text-nowrap" v-if="isEsOrNs">
                  Протокол заседания
                </th>
                <th></th>
                <th></th>
              </tr>
              </thead>
              <draggable
                v-if="experts_projects.counts"
                v-model="experts_projects.items"
                tag="tbody"
                handle=".drag-handle"
                @start="dragStart"
                @end="dragDrop"
              >
                <tr class="new"
                    unselectable="on"
                    v-for="project in experts_projects.items"
                    v-bind:key="project.ID"
                    style="cursor: default"
                    :class="
                    project.UF_IS_DELETE_AFTER_VIEW_SOVET &&
                    project.UF_IS_DELETE_AFTER_VIEW_SOVET == 1
                      ? 'document-file-delete accept-n'
                      : ''
                  "
                >
                  <td>
                    <a v-if="currentUser.TYPE_USER === 'manager' &&
                            experts_projects.IS_DRAGGBLE_QUESTION"
                       class="drag-and-drop-row drag-handle"
                    ></a>
                  </td>
                  <td>
                    {{ project.UF_SORT }}
                    <span
                      class="warning-point"
                      v-show="
                        !project.UF_IS_DONE &&
                          project.UF_IS_DELETE_AFTER_VIEW_SOVET &&
                          project.UF_IS_DELETE_AFTER_VIEW_SOVET != 1
                      "
                    >!</span
                    >
                    <template v-if="project.UF_IS_DELETE_AFTER_VIEW_SOVET == 1"
                    >&nbsp;
                    </template
                    >
                  </td>
                  <td v-if="typeSovetCode !== 'rgc'">{{ project.PROJECT_UF_NUMBER }}</td>
                  <td v-if="typeSovetCode !== 'rgc'">{{ project.COMPANY.FULLNAME }}</td>
                  <td v-if="typeSovetCode !== 'rgc'">{{ project.PROGRAM.NAME }}</td>
                  <td>
                    <router-link
                      :to="{
                        name: 'Questions',
                        params: {
                          id: listConfig.id,
                          projectId: project.ID
                        }
                      }"
                      style="color: #337ab7"
                    >{{
                        project.TYPE_QUESTION.CODE == "project"
                          ? project.PROJECT_UF_NAME
                          : project.UF_NAME
                      }}
                    </router-link>
                  </td>
                  <td>{{ project.TYPE_QUESTION.NAME }}</td>
                  <!--<td>{{ project.TYPE_MAKING.NAME }}</td>-->
                  <td v-if="typeSovetCode !== 'rgc'">{{ project.STATUS.NAME }}</td>
                  <td>{{ project.SPEAKER.NAME }}</td>
                  <td v-if="typeSovetCode !== 'rgc'">{{ project.UF_SUM_REQUEST | toCurrency }}</td>
                  <td v-if="isEsOrNs">
                    <template
                      v-if="
                        project.UF_PROTOKOL_FILE_ID > 0 &&
                          project.IS_EDIT_COLUMN_PROTOKOL == 1
                      "
                    >
                      <a
                        class="reestr-link-file"
                        href="javascript:void(0)"
                        @click="
                          sUploaderFileProtokolQuestion(project, 'edit')
                        "
                      >
                        {{ project.UF_PROTOKOL_FILE_ID_NAME }}
                      </a>
                    </template>
                    <template
                      v-else-if="
                        project.UF_PROTOKOL_FILE_ID > 0 &&
                          project.IS_EDIT_COLUMN_PROTOKOL != 1
                      "
                    >
                      <a
                        class="reestr-link-file"
                        href="javascript:void(0)"
                        @click="openDoc(project.UF_PROTOKOL_FILE_ID)"
                      >
                        {{ project.UF_PROTOKOL_FILE_ID_NAME }}
                      </a>
                    </template>
                    <button
                      v-else-if="project.IS_EDIT_COLUMN_PROTOKOL == 1"
                      class="project-filter__butt-btn butt-new-style stl-w-full butt-new-style-small butt-new-style-small-reestr"
                      type="button"
                      @click="
                        sUploaderFileProtokolQuestion(project, 'add')
                      "
                    >
                      Загрузить
                    </button>
                  </td>
                  <td>
                    <a
                      v-if="
                        project.IS_EDIT &&
                          project.IS_EDIT_ROW &&
                          project.UF_IS_DELETE_AFTER_VIEW_SOVET != 1
                      "
                      @click="getItem(project)"
                      class="link-edit-row"
                    ></a>
                  </td>
                  <td>
                    <a
                      v-if="
                        project.IS_EDIT &&
                          project.IS_EDIT_ROW &&
                          project.UF_IS_DELETE_AFTER_VIEW_SOVET != 1
                      "
                      @click="
                        showDeleteProject = true;
                        tempProject = project;
                      "
                      class="link-delete-row"
                    ></a>
                  </td>
                </tr>
              </draggable>
              <tbody v-else>
              <tr>
                <td :colspan="isEsOrNs ? 12 : 11">Вопросы не найдены</td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <td :colspan="isEsOrNs ? 12 : 11">
                  <div class="paging">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="col-xs-6 mycol">
                          <Pagination
                            :pages="pages"
                            :currentPage.sync="currentPage"
                          ></Pagination>
                        </div>
                        <div class="col-xs-6 mycol">
                          <div class="pull-right page-total">
                              <span style="padding-right: 15px"
                              >Всего: {{ experts_projects.counts }}</span
                              >
                            <span>Выводить по</span>
                            <span>
                                <select
                                  class="page-select"
                                  v-model="itemsPerPage"
                                >
                                  <option value="10">10</option>
                                  <option value="20">20</option>
                                  <option value="40">40</option>
                                  <option value="100">100</option>
                                  <option value="500">500</option>
                                </select>
                              </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              </tfoot>
            </table>
          </div>
          <div v-else>
            <h3>Загрузка...</h3>
          </div>
          <div
            v-if="showCreateNewProject"
            class="modal fade in"
            v-bind:class="{ show: showCreateNewProject }"
            tabindex="-1"
            role="dialog"
          >
            <form v-on:submit.prevent="onCreateProject">
              <div
                class="modal-dialog modal-close-active modal-new-style"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      v-on:click="showCreateNewProject = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Добавление вопроса</h4>
                  </div>
                  <div class="modal-body">
                    <div
                      class="alert alert-danger"
                      v-show="addError !== ''"
                      role="alert"
                    >
                      {{ addError }}
                    </div>
                    <div class="form-group">
                      <label>Тип вопроса</label>
                      <select
                        class="form-control"
                        v-model="newProject.type_question"
                      >
                        <option value="" disabled>Укажите тип вопроса</option>
                        <option
                          v-for="item in questionTypeOptions"
                          v-bind:key="item.ID"
                          v-bind:value="item.ID"
                          v-text="item.NAME"
                        ></option>
                      </select>
                    </div>
                    <div
                      class="form-group"
                      v-if="
                        newProject.type_question > 0 &&
                          (getQTypeProjectId(newProject.type_question) > 0 ||
                            getQTypeTechnicalId(newProject.type_question) > 0)
                      "
                    >
                      <label>Проект</label>
                      <v-autocomplete
                        :items="items"
                        input-class="form-control"
                        :auto-select-one-item="false"
                        :keep-open="false"
                        :component-item="act"
                        v-model="selectedAddress"
                        :min-len="1"
                        :get-label="getLabel"
                        placeholder="Введите номер проекта"
                        @update-items="updateItems"
                      ></v-autocomplete>
                      <template
                        v-if="
                          newProject.type_question > 0 &&
                            getQTypeTechnicalId(newProject.type_question) > 0
                        "
                      >
                        <p v-show="false">
                          <input type="checkbox" />&nbsp;&nbsp;<span
                          style="font-size: 11px;"
                        >Получить данные из КЗ</span
                        >
                        </p>
                      </template>
                    </div>
                    <div
                      class="form-group"
                      v-if="
                        newProject.type_question > 0 &&
                          getQTypeProjectId(newProject.type_question) > 0
                      "
                    >
                      <label>Тип вынесения</label>
                      <select
                        class="form-control"
                        v-model="newProject.type_making"
                        id="type_making_add"
                      >
                        <option value="" disabled
                        >Укажите тип вынесения проекта
                        </option>
                        <option
                          v-for="item in directory.type_making"
                          v-bind:key="item.ID"
                          v-bind:value="item.ID"
                          v-text="item.NAME"
                        ></option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>№ п/п</label>
                      <select
                        class="form-control form-control_dis"
                        v-model="newProject.uf_sort"
                        id="sort_add"
                      >
                        <option value="" disabled selected
                        >Укажите номер вопроса
                        </option>
                        <option
                          v-for="item in 100"
                          v-bind:key="item"
                          v-bind:value="item"
                          :disabled="!checkIsVisibleDisable(item)"
                          v-text="item"
                          class="form-control"
                        ></option>
                      </select>
                    </div>
                    <div
                      class="form-group"
                      v-if="
                        newProject.type_question > 0 &&
                          (getQTypeTechnicalId(newProject.type_question) > 0 ||
                            getQTypeFreeQuestionId(newProject.type_question) > 0 ||
                            getQTypeRequestCifraId(newProject.type_question)  > 0 )
                      "
                    >
                      <label>Название вопроса</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Введите название вопроса"
                        v-model="newProject.name"
                      />
                    </div>
                    <div
                      class="form-group"
                      v-if="
                        newProject.type_question > 0 &&
                          (getQTypeTechnicalId(newProject.type_question) > 0 ||
                            getQTypeFreeQuestionId(newProject.type_question)  > 0 ||
                            getQTypeRequestCifraId(newProject.type_question)  > 0 )
                      "
                    >
                      <label>Докладчик</label>
                      <Multiselect
                        label="FIO_FULL"
                        class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                        :limit="1"
                        :limitText="filterItemText"
                        track-by="ID"
                        v-model="newProject.speaker_id"
                        :options="allFondUserList"
                        :multiple="false"
                        placeholder="Укажите докладчика"
                        style="background-image: none;"
                      >
                        <span slot="noOptions">Пользователи не найдены</span>
                        <span slot="noResult">Пользователи не найдены</span>
                      </Multiselect>
                    </div>
                    <div class="form-group">
                      <label>Комментарий</label>
                      <textarea
                        class="form-control"
                        v-model="newProject.comment"
                        placeholder="Укажите комментарий к вопросу"
                        style="resize: vertical;"
                      ></textarea>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-default"
                      data-dismiss="modal"
                      v-on:click="clearForm()"
                    >
                      Отмена
                    </button>
                    <button
                      type="submit"
                      v-bind:disabled="isProjectLoading"
                      class="btn btn-primary"
                    >
                      Создать
                    </button>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
              <!-- /.modal-dialog -->
            </form>
          </div>
          <!-- /.modal -->
          <div
            class="modal fade in"
            v-bind:class="{ show: showEditNewProject }"
            tabindex="-1"
            role="dialog"
          >
            <form v-on:submit.prevent="onEditProject">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      v-on:click="showEditNewProject = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Редактирование вопроса</h4>
                  </div>
                  <div class="modal-body">
                    <div
                      class="alert alert-danger"
                      v-show="addError !== ''"
                      role="alert"
                    >
                      {{ addError }}
                    </div>

                    <div class="form-group" v-show="false">
                      <label>Тип вопроса</label>
                      <select
                        class="form-control"
                        v-model="newProject.type_question"
                        disabled
                      >
                        <option
                          v-for="item in questionTypeOptions"
                          v-bind:key="item.ID"
                          v-bind:value="item.ID"
                          v-text="item.NAME"
                        ></option>
                      </select>
                    </div>

                    <div
                      class="form-group"
                      v-if="
                        newProject.type_question > 0 &&
                          (getQTypeProjectId(newProject.type_question) > 0 ||
                            getQTypeTechnicalId(newProject.type_question) > 0)
                      "
                      v-show="false"
                    >
                      <label>Проект</label>
                      <input
                        type="text"
                        class="form-control"
                        disabled
                        v-model="newProject.name"
                      />
                      <!--<template
                        v-if="
                        newProject.type_question > 0 &&
                        (getQTypeTechnicalId(newProject.type_question) > 0)
                      "
                        v-show="false"
                      >
                        <input type="checkbox">&nbsp;&nbsp;<span style="font-size: 11px;">Получить данные из КЗ</span>
                      </template>-->
                    </div>

                    <div
                      class="form-group"
                      v-if="
                        newProject.type_question > 0 &&
                          getQTypeProjectId(newProject.type_question) > 0
                      "
                      v-show="false"
                    >
                      <label>Тип вынесения</label>
                      <select
                        class="form-control"
                        v-model="newProject.type_making"
                      >
                        <option
                          v-for="item in directory.type_making"
                          v-bind:key="item.ID"
                          v-bind:value="item.ID"
                          v-text="item.NAME"
                        ></option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label>Порядок рассмотрения</label>
                      <select class="form-control" v-model="newProject.uf_sort">
                        <option :value="item"></option>
                        <option
                          v-for="item in 100"
                          v-bind:key="item"
                          v-bind:value="item"
                          v-text="item"
                          :disabled="checkDisable(item)"
                          class="form-control"
                        ></option>
                      </select>
                    </div>

                    <div
                      class="form-group"
                      v-show="false"
                      v-if="
                        newProject.type_question > 0 &&
                          (getQTypeTechnicalId(newProject.type_question) > 0 ||
                            getQTypeFreeQuestionId(newProject.type_question) >
                              0)
                      "
                    >
                      <label>Название вопроса</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="newProject.question_name"
                      />
                    </div>

                    <div
                      class="form-group"
                      v-if="
                        newProject.type_question > 0 &&
                          (getQTypeTechnicalId(newProject.type_question) > 0 ||
                            getQTypeFreeQuestionId(newProject.type_question) >
                              0)
                      "
                      v-show="false"
                    >
                      <label>Докладчик</label>
                      <Multiselect
                        label="FIO_FULL"
                        class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                        :limit="1"
                        :limitText="filterItemText"
                        track-by="ID"
                        v-model="newProject.speaker_id"
                        :options="allFondUserList"
                        :multiple="false"
                        placeholder="Укажите докладчика"
                        style="background-image: none;"
                      >
                        <span slot="noOptions">Пользователи не найдены</span>
                        <span slot="noResult">Пользователи не найдены</span>
                      </Multiselect>
                    </div>

                    <div class="form-group" v-show="false">
                      <label>Комментарий</label>
                      <textarea
                        class="form-control"
                        v-model="newProject.comment"
                        style="resize: vertical;"
                      ></textarea>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-default"
                      data-dismiss="modal"
                      v-on:click="clearForm()"
                    >
                      Отмена
                    </button>
                    <button type="submit" class="btn btn-primary">
                      Редактировать
                    </button>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
              <!-- /.modal-dialog -->
            </form>
          </div>
          <!-- /.modal -->

          <!-- Удалить вопрос -->
          <div
            class="modal fade in"
            id=""
            tabindex="-1"
            role="dialog"
            v-bind:class="{ show: showDeleteProject }"
          >
            <form>
              <div
                class="modal-dialog modal-dialog-md modal-new-style modal-dialog-centered"
                role="document"
              >
                <div
                  class="modal-content"
                  :style="
                    isDeleteProjectQuestion(tempProject)
                      ? 'min-width: 600px;'
                      : ''
                  "
                >
                  <div class="modal-header">
                    <button type="button" class="close" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title" style="text-align: center">
                      Удалить вопрос?
                    </h4>
                  </div>
                  <div class="modal-body">
                    <div class="form-group">
                      <p v-if="isDeleteProjectQuestion(tempProject)">
                        Для удаления вопроса №{{ tempProject.UF_SORT }} из
                        заседаний нужно выбрать новую дату заседания или
                        прекратить работу по проекту. Как поступим?
                      </p>
                      <p v-else>
                        Вы действительно хотите удалить вопрос №{{
                          tempProject.UF_SORT
                        }}? Данное действие невозможно будет восстановить.
                      </p>
                    </div>
                  </div>
                  <div
                    class="modal-footer df-js-b"
                    v-if="isDeleteProjectQuestion(tempProject)"
                  >
                    <button
                      type="button"
                      class="butt-stl butt-stl-small2 butt-green"
                      style="padding: 8px;"
                      data-dismiss="modal"
                      @click="setDataTransferProject(tempProject)"
                    >
                      Выбрать новое заседание
                    </button>

                    <button
                      type="button"
                      class="butt-stl butt-stl-small2 butt-yellow"
                      style="padding: 8px;"
                      data-dismiss="modal"
                      @click="
                        showDeleteProject = false;
                        showDialogEndWorkProject = true;
                      "
                    >
                      Прекратить работу по проекту
                    </button>

                    <button
                      type="button"
                      class="butt-stl butt-stl-small2 butt-red"
                      style="padding: 8px;"
                      @click="showDeleteProject = false"
                    >
                      Закрыть
                    </button>
                  </div>
                  <div class="modal-footer df-js-b" v-else>
                    <button
                      type="button"
                      class="butt-stl butt-green"
                      data-dismiss="modal"
                      @click="deleteItem(tempProject)"
                    >
                      Да
                    </button>
                    <button
                      type="button"
                      class="butt-stl
                      butt-red"
                      @click="showDeleteProject = false"
                    >
                      Нет
                    </button>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
              <!-- /.modal-dialog -->
            </form>
          </div>
          <!-- /.modal -->
          <!-- Удалить вопрос -->
          <!-- Диалог смены ЭС для проекта -->
          <div
            class="modal fade in"
            id=""
            tabindex="-1"
            role="dialog"
            v-bind:class="{ show: showChangeSovet }"
          >
            <form v-on:submit.prevent="onSendTransferProject">
              <div
                class="modal-dialog modal-dialog-md modal-new-style modal-dialog-centered"
                role="document"
              >
                <div class="modal-content" style="min-width: 600px;">
                  <div class="modal-header">
                    <button type="button" class="close" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Выберите заседание</h4>
                  </div>
                  <div class="modal-body">
                    <div class="form-group">
                      <label>
                        Номер заседания
                      </label>
                      <select
                        class="form-control"
                        @change="changeTransferProject"
                        v-model="transferProject.id_sovet"
                      >
                        <option
                          v-for="item in experts_projects.LIST_SOVET_ACTUAL"
                          v-bind:key="item.ID"
                          v-bind:value="item.ID"
                          v-text="item.LABEL"
                          v-if="
                            item.UF_TYPE_SOVET.CODE ===
                              typeSovetCode
                          "
                          class="form-control"
                        ></option>
                      </select>

                      <template v-if="isViewTransferFormProject">
                        <div class="form-group">
                          <h4
                            class="modal-title"
                            style="font-size: 16px; font-weight: 600;"
                          >
                            Добавление вопроса
                          </h4>
                        </div>
                        <div class="form-group">
                          <label>Тип вопроса</label>
                          <select
                            class="form-control"
                            disabled
                            v-model="transferProject.type_question"
                          >
                            <option value="" disabled
                            >Укажите тип вопроса
                            </option
                            >
                            <option
                              v-for="item in directory.sp_question_expert_sovet_type"
                              v-bind:key="item.ID"
                              v-bind:value="item.ID"
                              v-text="item.NAME"
                            ></option>
                          </select>
                        </div>
                        <div class="form-group">
                          <label>Проект</label>
                          <select
                            class="form-control"
                            disabled
                            v-model="transferProject.projectId"
                          >
                            <option value="" disabled
                            >Укажите тип вопроса
                            </option
                            >
                            <option
                              v-bind:key="transferProject.projectId"
                              v-bind:value="transferProject.projectId"
                              v-text="transferProject.projectNumber"
                            ></option>
                          </select>
                        </div>
                        <div class="form-group">
                          <label>Тип вынесения</label>
                          <select
                            class="form-control"
                            v-model="transferProject.type_making"
                            id="type_making_add"
                          >
                            <option value="" disabled
                            >Укажите тип вынесения проекта
                            </option>
                            <option
                              v-for="item in directory.type_making"
                              v-bind:key="item.ID"
                              v-bind:value="item.ID"
                              v-text="item.NAME"
                            ></option>
                          </select>
                        </div>
                        <div class="form-group">
                          <label>№ п/п</label>
                          <select
                            class="form-control form-control_dis"
                            v-model="transferProject.uf_sort"
                            id="sort_add"
                          >
                            <option value="" disabled selected
                            >Укажите номер вопроса
                            </option>
                            <option
                              v-for="item in 100"
                              v-bind:key="item"
                              v-bind:value="item"
                              :disabled="checkIsVisibleDisableTranspher(item)"
                              v-text="item"
                              class="form-control"
                            ></option>
                          </select>
                        </div>
                        <div class="form-group">
                          <label>Комментарий</label>
                          <textarea
                            class="form-control"
                            v-model="transferProject.comment"
                            placeholder="Укажите комментарий к вопросу"
                            style="resize: vertical;"
                          ></textarea>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-default"
                      @click="
                        showChangeSovet = false;
                        isViewTransferFormProject = false;
                        transferProject.id_sovet = null;
                      "
                    >
                      Отмена
                    </button>
                    <button
                      type="submit"
                      class="btn btn-primary"
                      data-dismiss="modal"
                    >
                      Создать
                    </button>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
              <!-- /.modal-dialog -->
            </form>
          </div>
          <!-- Диалог смены ЭС для проекта end -->

          <!-- дополнительный вопрос - полная блокировка ЭС -->
          <div
            class="modal fade in"
            v-bind:class="{ show: showDialogEndWorkProject }"
            tabindex="-1"
            role="dialog"
          >
            <form>
              <div
                class="modal-dialog modal-dialog-md modal-new-style modal-dialog-centered"
                role="document"
              >
                <div class="modal-content" style="min-width: 580px;">
                  <div class="modal-header">
                    <button type="button" class="close" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title" style="text-align: center;">
                      Удалить вопрос?
                    </h4>
                  </div>
                  <div class="modal-body">
                    <div class="form-group">
                      <p>
                        Вы точно уверены в том, что хотите исключить проект из
                        повестки и прекратить работу по нему? В случае
                        положительного ответа - статус проекта изменится на
                        "Работа по проекту прекращена", вернуть назад его уже не
                        получится.
                      </p>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="butt-stl butt-stl-small2  butt-yellow"
                      v-on:click="setEndWorkProject()"
                    >
                      Прекратить работу по проекту
                    </button>
                    <button
                      type="button"
                      class="butt-stl butt-stl-small2 butt-red"
                      data-dismiss="modal"
                      v-on:click="showDialogEndWorkProject = false"
                    >
                      Закрыть
                    </button>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
              <!-- /.modal-dialog -->
            </form>
          </div>

          <!-- Загрузка файла Протокол заседания по вопросу -->
          <div
            class="modal fade in"
            :class="{ show: showUploaderProtokolQuestionFile }"
            tabindex="-1"
            role="dialog"
          >
            <form
              action="#"
              @submit.prevent="submitProtokolQuestion"
              style="padding-right: 20px"
            >
              <div
                role="document"
                class="modal-dialog modal-new-style modal-close-active"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      aria-label="Close"
                      data-dismiss="modal"
                      @click="showUploaderProtokolQuestionFile = false"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Протокол заседания</h4>
                  </div>
                  <div class="modal-body" style="margin-bottom: 0px;">
                    <div
                      class="form-group"
                      v-if="itemProtokolTemp.UF_PROTOKOL_FILE_ID > 0"
                    >
                      <div class="upload-file-area">
                        <label class="upload-file-area__label">
                          <span class="upload-file-area__text">
                            <i class="icon-item icon-img-upload"></i>
                            <a
                              href="javascript:void(0)"
                              @click="openDoc(itemProtokolTemp.UF_PROTOKOL_FILE_ID)"
                              v-text="itemProtokolTemp.UF_PROTOKOL_FILE_ID_NAME"
                            ></a>
                          </span>
                          <button
                            class="butt-stl butt-red upload-file-area__btn-remove"
                            type="button"
                            @click="sDeleteFileProtokolQuestionDialog"
                          >
                            Удалить
                          </button>
                        </label>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="upload-file-area">
                        <input
                          class="upload-file-area__input"
                          type="file"
                          name="file"
                          id="inp-file-question-protokol"
                          ref="fileProtokolQuestion"
                          @change="changeFileProtokolQuestion"
                        />
                        <label
                          for="inp-file-question-protokol"
                          class="upload-file-area__label"
                          v-if="fileProtokolQuestionName"
                        >
                          <span class="upload-file-area__text">
                            <i class="icon-item icon-img-upload"></i>
                            <span v-text="fileProtokolQuestionName"></span>
                            <span v-text="fileProtokolQuestionName2"></span>
                          </span>
                          <button
                            v-if="fileProtokolQuestionName2"
                            class="butt-stl butt-red upload-file-area__btn-remove"
                            type="button"
                            @click="clearFileProtokolQuestion"
                          >
                            Очистить
                          </button>
                        </label>
                      </div>
                      <div class="alert alert-info">
                        Максимальный размер файла для загрузки - 100 Мб.
                      </div>
                      <div
                        v-if="errorTextProtokolQuestion"
                        class="alert alert-danger"
                      >
                        {{ errorTextProtokolQuestion }}
                      </div>
                      <div
                        v-for="err in errorArrProtokolQuestion"
                        class="alert alert-danger"
                        style="margin-top: 10px"
                      >
                        {{ err.TEXT }}
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="submit"
                      class="butt-stl butt-blue"
                      :disabled="uploadProtokolQuestionBlock"
                    >
                      Сохранить
                    </button>
                    <button
                      type="button"
                      data-dismiss="modal"
                      class="butt-stl butt-black"
                      @click="showUploaderProtokolQuestionFile = false"
                    >
                      Отмена
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <!-- /Загрузка файла Протокол заседания по вопросу -->

          <!-- Удалить файл Протокол заседания по вопросу -->
          <div
            class="modal fade in"
            tabindex="-1"
            v-bind:class="{ show: showDialogDeleteFileProtokolQuestion }"
            role="dialog"
          >
            <form>
              <div class="modal-dialog modal-new-style" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">
                      Удалить файл протокола заседания?
                    </h4>
                  </div>
                  <div class="modal-body">
                    <div class="form-group">
                      <p>
                        Вы действительно хотите удалить файл протокола
                        заседания? Данное действие невозможно будет отменить.
                      </p>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="butt-stl butt-black"
                      data-dismiss="modal"
                      v-on:click="showDialogDeleteFileProtokolQuestion = false"
                    >
                      отменить
                    </button>
                    <button
                      type="button"
                      v-on:click="deleteFileProtokolQuestion()"
                      class="butt-stl butt-red"
                    >
                      Удалить
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <!-- /Удалить файл Протокол заседания по вопросу -->
        </div>
      </div>
      <!-- wraper -->
    </div>
    <div class="footer footer-fix">
      <div class="container-fluid mycontainer-fluid">
        <div class="myfooter">
          <div class="myfooter-frp pull-left"></div>
          <div
            class="pull-right"
            v-if="
              experts_projects.IS_BLOCK_SOVET !== 1 &&
                experts_projects.IS_BLOCK_SOVET !== 3
            "
          >
            <a
              class="btn btn-success"
              style="margin-right: 12px;padding: 3px 12px"
              @click="showCreateNewProject = true"
            >Добавить</a
            >
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import Pagination from "@/components/Pagination";
import { mapGetters } from "vuex";
import Vue from "vue";
import {
  FETCH_PROJECT_TYPES,
  SET_MAIN_MENU,
  FETCH_DIRECTORIES,
  FETCH_EXPERT_PROJECT_LIST,
  SET_IS_VIEW_ALL_EXPERTISE
} from "@/store/actions.type";
import { ExpertAdvice, ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Item from "@/components/expert/Item";
import Multiselect from "vue-multiselect";
import draggable from "vuedraggable";

Vue.filter("toCurrency", function(value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("ru-RU", {
    style: "decimal",
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

export default {
  name: "EAList",
  title: "Вопросы совета",
  components: {
    Multiselect,
    Pagination,
    draggable
  },
  data() {
    return {
      adviceSort: {
        ID: "",
        uf_sort: ""
      },
      extendFilter: false,
      filter: {
        status: [],
        name: "",
        program: [],
        number: "",
        org_name: "",
        archive: "",
        region: "",
        uf_sort: "",
        type_making: "",
        is_done_question: "",
        type_question: "",
        UF_SPEAKER_ID: []
      },
      itemsPerPage: 10,
      currentPage: 1,
      sortOrder: "",
      sortColumn: "",
      showCreateNewProject: false,
      showEditNewProject: false,
      sp: {
        statuses: []
      },
      newProject: {
        support_prog_id: "",
        name: "",
        type_question: "",
        uf_sort: "",
        type_making: "",
        question_name: "",
        speaker_id: 0
      },
      transferProject: {
        id_question: 0,
        id_sovet: 0,
        type_question: "",
        uf_sort: "",
        type_making: "",
        comment: "",
        projectId: 0,
        projectNumber: ""
      },
      addError: "",
      addresses: [],
      addressSearch: "",
      selectedAddress: null,
      items: [],
      act: Item,
      ea: {},
      sortNumbeAdvice: [],
      showDeleteProject: false,
      tempProject: [],
      isAdminRights: false,
      isButtonView: false,
      showChangeSovet: false,
      isViewTransferFormProject: false,
      showDialogEndWorkProject: false,
      showUploaderProtokolQuestionFile: false,
      showDialogDeleteFileProtokolQuestion: false,
      itemProtokolTemp: {},
      fileProtokolQuestionName: "Файл не выбран",
      fileProtokolQuestionName2: "",
      errorTextProtokolQuestion: "",
      errorArrProtokolQuestion: [],
      uploadProtokolQuestionBlock: false
    };
  },
  async mounted() {
    await this.$store.dispatch(SET_MAIN_MENU, []);
    if (this.currentUser.TYPE_USER === "manager") {
      ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          data.IS_VIEW_ALL_EXPERTISE
        );
        let navMainMenu = [];
        if (data.START_PAGE === "REESTR_PROJECTS") {
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
          /*if (data.IS_VIEW_MONITOR_LIZING) {
            navMainMenu.push({
              name: "Мониторинг Лизинговых<br/> компаний",
              class: "two_line",
              route: "MonitoringLizingOrgs"
            });
          }*/
          if (data.IS_VIEW_PLAN_ES) {
            navMainMenu.push({
              name: "Заседания",
              route: "Experts"
            });
          }
          if (
            data.IS_VIEW_VOTE_SOVETE_MODULE &&
            data.IS_VIEW_VOTE_SOVETE_MENU
          ) {
            navMainMenu.push({
              name: "Заседания",
              route: "Conference"
            });
          }
          /*navMainMenu.push({
            name: "Запросы",
            route: "Requests"
          });*/
        } else {
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
          /*if (data.IS_VIEW_MONITOR_LIZING) {
            navMainMenu.push({
              name: "Мониторинг Лизинговых<br/> компаний",
              class: "two_line",
              route: "MonitoringLizingOrgs"
            });
          }*/
          if (data.IS_VIEW_PLAN_ES) {
            navMainMenu.push({
              name: "Заседания",
              route: "Experts"
            });
          }

          if (data.IS_VIEW_REQUEST_MODULE) {
            navMainMenu.push({
              name: "Запросы",
              route: "Requests"
            });
          }
          if (
            data.IS_VIEW_VOTE_SOVETE_MODULE &&
            data.IS_VIEW_VOTE_SOVETE_MENU
          ) {
            navMainMenu.push({
              name: "Заседания",
              route: "Conference"
            });
          }
          /*navMainMenu.push({
            name: "Запросы",
            route: "Requests"
          });*/
        }
        if (data.IS_VIEW_VOTE_SOVETE_MODULE && !data.IS_VIEW_VOTE_SOVETE_MENU) {
          this.isAdminRights = true;
        }
        this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          data.IS_VIEW_ALL_EXPERTISE
        );
      });
    } else {
      await this.$store.dispatch(SET_MAIN_MENU, [
        {
          name:
            this.currentUser.TYPE_USER === "manager"
              ? "Реестр проектов"
              : "Мои проекты",
          route: "Projects"
        }
      ]);
    }
    await this.$store.dispatch(FETCH_DIRECTORIES, [
      "status",
      "program_fin_support",
      "type_making",
      "sp_question_expert_sovet_type"
    ]);

    await ExpertAdvice.getItem(this.$route.params.id).then(({ data }) => {
      this.ea = data;
    }, this).catch( error => {
      if (error.message.includes("HttpCode:403")) {
        this.$router.push({ name: "ForbiddenPage403" });
      }
      if (error.message.includes("HttpCode:404")) {
        this.$router.push({ name: "NotFoundPage404" });
      }
    });

    this.fetchProjects();
    console.log(this.currentUser.TYPE_USER);
  },
  computed: {
    ...mapGetters([
      "experts_projects",
      "userProjectProgrammes",
      "isProjectLoading",
      "addProjectError",
      "project",
      "isEAsLoading",
      "DStatus",
      "DProgramFinSupport",
      "currentUser",
      "directory"
    ]),

    isEsOrNs() {
      const code =
        this.ea &&
        this.ea.UF_TYPE_SOVET_ID_OBJECT &&
        this.ea.UF_TYPE_SOVET_ID_OBJECT.CODE;
      return code === "es" || code === "ns";
    },

    typeSovetCode() {
      return (
        (this.ea &&
          this.ea.UF_TYPE_SOVET_ID_OBJECT &&
          this.ea.UF_TYPE_SOVET_ID_OBJECT.CODE) ||
        ""
      );
    },

    typeSovetName() {
      return (
        (this.ea &&
          this.ea.UF_TYPE_SOVET_ID_OBJECT &&
          this.ea.UF_TYPE_SOVET_ID_OBJECT.NAME) ||
        ""
      );
    },

    speakerList() {
      return (this.experts_projects.SPEAKER_LIST || []).filter(Boolean);
    },

    allFondUserList() {
      return (this.experts_projects.ALL_FOND_USER_LIST || []).filter(Boolean);
    },

    programList() {
      return (this.DProgramFinSupport || []).filter(Boolean);
    },

    statusList() {
      return ((this.directory && this.directory.status) || []).filter(Boolean);
    },

    questionTypeOptions() {
      const managerRoles = ["admin", "manager3", "secretary_of_councils", "director"];
      const code = this.typeSovetCode;
      return this.directory.sp_question_expert_sovet_type.filter(item => {
        if (code === "rgc" && item.CODE !== "request_cifra" && item.CODE !== "free_question") {
          return false;
        }
        return item.IS_ADD_ONLY_MANAGER == 1
          ? managerRoles.includes(this.currentUser.ACTIVE_ROLE_CODE)
          : true;
      });
    },

    createProjectButton() {
      return user.TYPE_USER === "manager";
    },
    listConfig() {
      const q = {
        page: this.currentPage,
        limit: this.itemsPerPage,
        filter: {}
      };
      if (this.sortColumn !== "") {
        let sort = {
          column: "",
          order: ""
        };
        sort.column = this.sortColumn;
        sort.order = this.sortOrder;
        q.sort = sort;
      }
      if (this.filter.status.length > 0) {
        q.filter.UF_STATUS_ID = this.filter.status;
      }
      if (this.filter.program.length > 0) {
        q.filter.UF_SUPPORT_PROG_ID = this.filter.program;
      }
      if (this.filter.UF_SPEAKER_ID.length > 0) {
        q.filter.UF_SPEAKER_ID = this.filter.UF_SPEAKER_ID;
      }
      if (this.filter.type_making > 0) {
        q.filter.UF_TYPE_MAKING = this.filter.type_making;
      }
      if (this.filter.name !== "") {
        q.filter.UF_NAME = this.filter.name;
      }
      if (this.filter.uf_sort > 0) {
        q.filter.UF_SORT = this.filter.uf_sort;
      }
      if (this.filter.number !== "") {
        q.filter.UF_NUMBER = this.filter.number;
      }
      if (this.filter.archive !== "") {
        q.filter.UF_IS_ARHIVE = this.filter.archive;
      }
      if (this.filter.org_name !== "") {
        q.filter.COMPANY_NAME = this.filter.org_name;
      }
      if (this.filter.is_done_question !== "") {
        q.filter.UF_IS_DONE = this.filter.is_done_question;
      }
      if (this.filter.type_question > 0) {
        q.filter.UF_TYPE_QUESTION = this.filter.type_question;
      }

      return q;
    },
    pages() {
      console.log(this.isEAsLoading, this.experts_projects);
      console.log("сорт массив: ", this.sortNumbeAdvice);
      if (
        this.isEAsLoading ||
        this.experts_projects.counts <= this.itemsPerPage
      ) {
        return [];
      }
      return [
        ...Array(
          Math.ceil(this.experts_projects.counts / this.itemsPerPage)
        ).keys()
      ].map(e => e + 1);
    }
  },
  watch: {
    currentPage(newValue) {
      this.listConfig.page = newValue;
      this.fetchProjects();
    },
    itemsPerPage(newValue) {
      this.listConfig.limit = newValue;
      this.fetchProjects();
    },
    addressSearch(addr) {
      this.getAddresses(addr);
    }
  },
  methods: {
    getTitlePage() {
      return (
        "Вопросы на " +
        this.typeSovetName +
        " № " +
        this.ea.UF_NUMBER
      );
    },
    getPTypeId(id) {
      let t = this.directory.program_fin_support.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0].NAME;
      }
      return "";
    },
    getQTypeProjectId(id) {
      let t = this.directory.sp_question_expert_sovet_type.filter(
        c => c.ID === id
      );
      if (t.length > 0 && t[0].CODE === "project") {
        return t[0].ID;
      }
      return "";
    },
    getQTypeTechnicalId(id) {
      let t = this.directory.sp_question_expert_sovet_type.filter(
        c => c.ID === id
      );
      if (t.length > 0 && t[0].CODE === "technikal") {
        return t[0].ID;
      }
      return "";
    },
    getQTypeFreeQuestionId(id) {
      let t = this.directory.sp_question_expert_sovet_type.filter(
        c => c.ID === id
      );
      if (t.length > 0 && t[0].CODE === "free_question") {
        return t[0].ID;
      }
      return "";
    },

    getQTypeRequestCifraId(id) {
      let t = this.directory.sp_question_expert_sovet_type.filter(
        c => c.ID === id
      );
      if (t.length > 0 && t[0].CODE === "request_cifra") {
        return t[0].ID;
      }
      return "";
    },

    setOrder(column) {
      if (this.sortColumn !== column) {
        this.sortOrder = "ASC";
      } else {
        if (this.sortOrder === "DESC") {
          this.sortOrder = "ASC";
        } else {
          this.sortOrder = "DESC";
        }
      }
      this.sortColumn = column;
      this.fetchProjects();
    },
    clearFilter() {
      this.filter = {
        status: "",
        name: "",
        program: "",
        number: "",
        org_name: "",
        archive: "",
        region: "",
        type_question: "",
        type_making: "",
        is_done_question: "",
        UF_SPEAKER_ID: ""
      };
      this.fetchProjects();
    },
    clearForm() {
      this.showCreateNewProject = false;
      this.showEditNewProject = false;

      this.newProject.type_making = 0;
      this.newProject.type_question = 0;
      this.newProject.comment = "";
      this.newProject.uf_sort = 0;
      this.newProject.ID = 0;
      this.newProject.name = "";
      this.newProject.question_name = "";
      this.newProject.speaker_id = 0;
      this.items = [];
    },
    onCreateProject() {
      ExpertAdvice.addProjectAdvice(this.$route.params.id, {
        UF_PROJECT_ID: this.selectedAddress ? this.selectedAddress.ID : "",
        UF_TYPE_QUESTION: this.newProject.type_question,
        UF_TYPE_MAKING: this.newProject.type_making,
        UF_NAME: this.newProject.name,
        UF_COMMENT: this.newProject.comment,
        UF_SORT: this.newProject.uf_sort,
        SPEAKER: this.newProject.speaker_id
      })
        .then(({ data }) => {
          if (data.error) {
            this.$toasted.show(data.errorArr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            this.fetchProjects();
            this.showCreateNewProject = false;
            this.selectedAddress = null;
            this.newProject.type_making = 0;
            this.newProject.type_question = 0;
            this.newProject.comment = "";
            this.newProject.uf_sort = 0;
            this.newProject.ID = 0;
            this.newProject.name = "";
            this.newProject.speaker_id = 0;
            this.items = [];
          }
        })
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    onEditProject() {
      ExpertAdvice.editProjectAdvice(
        this.$route.params.id,
        this.newProject.ID,
        {
          UF_PROJECT_ID:
            this.newProject.UF_PROJECT_ID > 0
              ? this.newProject.UF_PROJECT_ID
              : this.selectedAddress
                ? this.selectedAddress.ID
                : "",
          UF_TYPE_QUESTION: this.newProject.type_question,
          UF_TYPE_MAKING: this.newProject.type_making,
          UF_NAME: this.newProject.question_name,
          UF_COMMENT: this.newProject.comment,
          UF_SORT: this.newProject.uf_sort,
          SPEAKER: this.newProject.speaker_id,
          SORT_EDIT: 1
        }
      )
        .then(({ data }) => {
          if (data.error) {
            this.$toasted.show(data.errorArr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            this.fetchProjects();
            this.showEditNewProject = false;
          }
        })
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    onSortAdvice() {
      ExpertAdvice.setProjectAdvice(
        this.$route.params.id,
        this.adviceSort.ID,
        { UF_SORT: this.adviceSort.uf_sort }
      )
        .then(({ data }) => {
          if (data.error) {
            this.$toasted.show(data.errorArr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            this.experts_projects.items = this.experts_projects.items.map(item => {
              const match = data.items.find(i => i.ID === item.ID);
              return {
                ...item,
                ...match
              };
            });
          }
        })
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    dragStart(evt) {
      this.draggedOldIndex = evt.oldIndex;
      this.draggedItem = this.experts_projects.items[evt.oldIndex];
    },
    dragDrop(evt) {
      let targetItem = {};
      if (this.draggedOldIndex === evt.newIndex) {
        return;
      }
      if (this.draggedOldIndex < evt.newIndex) {
        targetItem = this.experts_projects.items[evt.newIndex - 1];
      } else {
        targetItem = this.experts_projects.items[evt.newIndex + 1];
      }

      this.adviceSort.ID = this.draggedItem.ID;
      this.adviceSort.uf_sort = targetItem.UF_SORT;

      this.onSortAdvice();
      // Очистка
      this.draggedItem = null;
      this.draggedOldIndex = null;
    },
    showCreateProjectPanel() {
      this.$store.dispatch(FETCH_PROJECT_TYPES).then(() => {
        this.addError = "";
        this.showCreateNewProject = true;
      });
    },

    fetchProjects() {
      this.listConfig.id = this.$route.params.id;
      this.$store.dispatch(FETCH_EXPERT_PROJECT_LIST, this.listConfig);
      this.setTitlePage();
    },
    setTitlePage() {
      document.title =
        "Вопросы на " +
        this.typeSovetName +
        " № " +
        this.ea.UF_NUMBER;
    },
    getLinkProjects() {
      ExpertAdvice.getLinkReestrAdviceProjectExcel(
        this.$route.params.id,
        this.listConfig
      ).then(({ data }) => {
        window.open(
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
          "_blank"
        );
      });
    },
    getLinkReport() {
      let link = "https://finereport.frprf.ru/decision/view/report?op=view&ref_c=1484096e-e8c9-438c-ab45-4589665ad67e&viewlet=FRP%252FReports%252FLK%252F%25D0%2593%25D0%25B5%25D0%25BD%25D0%25B5%25D1%2580%25D0%25B0%25D1%2586%25D0%25B8%25D1%258F%2B%25D0%25BF%25D0%25BE%25D0%25B2%25D0%25B5%25D1%2581%25D1%2582%25D0%25BA%25D0%25B8%2B%25D0%25B7%25D0%25B0%25D1%2581%25D0%25B5%25D0%25B4%25D0%25B0%25D0%25BD%25D0%25B8%25D1%258F.cpt&ref_t=design";
                //https://finereport.frprf.ru/decision/view/report?op=view&ref_c=1484096e-e8c9-438c-ab45-4589665ad67e&viewlet=FRP/Reports/LK/Генерация повестки заседания.cpt&ref_t=design
      /* let link =
        "http://rftr1500//ReportServer/Pages/ReportViewer.aspx?%2f%D0%9E%D1%82%D1%87%D0%B5%D1%82%D1%8B%2f%D0%A4%D0%A0%D0%9F%2f%D0%93%D0%B5%D0%BD%D0%B5%D1%80%D0%B0%D1%86%D0%B8%D1%8F%20%D0%BF%D0%BE%D0%B2%D0%B5%D1%81%D1%82%D0%BA%D0%B8%20%D0%B7%D0%B0%D1%81%D0%B5%D0%B4%D0%B0%D0%BD%D0%B8%D1%8F%20&expert_board_id=" +
        this.$route.params.id +
        "&rs:Command=Render";*/
      // "http://reporting/reports/report/%D0%9E%D1%82%D1%87%D0%B5%D1%82%D1%8B/%D0%A4%D0%A0%D0%9F/%D0%93%D0%B5%D0%BD%D0%B5%D1%80%D0%B0%D1%86%D0%B8%D1%8F%20%D0%BF%D0%BE%D0%B2%D0%B5%D1%81%D1%82%D0%BA%D0%B8%20%D0%B7%D0%B0%D1%81%D0%B5%D0%B4%D0%B0%D0%BD%D0%B8%D1%8F%20&expert_board_id=%3Cspan%20style=font-family:%20markup-bold;%3E" +
      // this.$route.params.id +
      // "%3C/span%3E&rs:Command=Render";
      window.open(link, "_blank");
    },
    getLinkReport2() {
      let link =
        "http://rftr1500//ReportServer/Pages/ReportViewer.aspx?%2f%D0%9E%D1%82%D1%87%D0%B5%D1%82%D1%8B%2f%D0%A4%D0%A0%D0%9F%2f%D0%98%D1%81%D0%BF%D0%BE%D0%BB%D0%BD%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%BF%D0%BE%D1%80%D1%83%D1%87%D0%B5%D0%BD%D0%B8%D0%B9%20%D0%BF%D0%BE%20%D0%B7%D0%B0%D1%81%D0%B5%D0%B4%D0%B0%D0%BD%D0%B8%D1%8F%D0%BC%20&board_id=" +
        this.$route.params.id +
        "&rs:Command=Render";
      window.open(link, "_blank");
    },
    getArchiveAll() {
      ExpertAdvice.getLinkFileArchiveAll(this.$route.params.id).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        },
        this
      );
    },
    async getAddresses(query) {
      await ExpertAdvice.searchProject({ search: query }).then(({ data }) => {
        let ad = [];
        for (let i = 0; i < data.length; i++) {
          ad.push({
            id: data[i].ID,
            text: data[i].UF_NAME
          });
        }
        let adj = JSON.stringify(ad);
        this.addresses = JSON.parse(adj);
      });
    },
    deleteItem(item) {
      //if (confirm("Удалить проект?")) {
      if (this.showDeleteProject) {
        ExpertAdvice.deleteProjectAdvice(item.ID).then(({ data }) => {
          if (data.errorAr && data.errorAr.length) {
            this.$toasted.show(data.errorAr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            this.showDeleteProject = false;
            this.fetchProjects();
          }
        }, this);
        return false;
      }
    },
    getItem(item) {
      if (item) {
        ExpertAdvice.getProjectAdvice(this.$route.params.id, item.ID)
          .then(({ data }) => {
            this.newProject.ID = item.ID;
            this.newProject.name =
              item.PROJECT_UF_NUMBER > 0
                ? item.PROJECT_UF_NUMBER + " " + item.PROJECT_UF_NAME
                : item.UF_NAME;

            this.newProject.question_name = item.UF_NAME;

            this.newProject.type_making = item.TYPE_MAKING.UF_TYPE_MAKING;
            this.newProject.type_question = item.TYPE_QUESTION.UF_TYPE_QUESTION;
            this.newProject.comment = data.UF_COMMENT;
            this.newProject.UF_PROJECT_ID = data.UF_PROJECT_ID;
            this.newProject.UF_SPEAKER_ID = data.UF_SPEAKER_ID;
            this.newProject.speaker_id = data.UF_SPEAKER_ID;
            (this.newProject.uf_sort = item.UF_SORT), this.getSortList();
            this.showEditNewProject = true;
          }, this)
          .catch(() => {
            this.addError = this.addProjectError;
          });
      }
      return false;
    },
    getSortList() {
      ExpertAdvice.getListSortNumberProjectsAdvice(this.$route.params.id).then(
        ({ data }) => {
          this.sortNumbeAdvice = data.UF_SORT;
        },
        this
      );
    },
    checkDisable(id) {
      return this.sortNumbeAdvice.includes(id);
    },
    checkIsVisibleDisable(id) {
      let t = this.experts_projects.itemsCount.filter(c => c.UF_SORT === id);
      return t.length === 0 ? true : false;
    },
    getLabel(item) {
      if (item) {
        return item.UF_NUMBER + " " + item.UF_NAME;
      }
    },
    updateItems(query) {
      ExpertAdvice.searchProject({ search: query }).then(({ data }) => {
        this.items = data;
      });
    },
    filterItemText(count) {
      console.log(count);
      return ``;
    },
    isDeleteProjectQuestion(tempProject) {
      const code = this.typeSovetCode;
      if (
        (code === "es" || code === "ns") &&
        tempProject.TYPE_MAKING
      ) {
        if (
          tempProject.TYPE_MAKING.CODE &&
          (tempProject.TYPE_MAKING.CODE === "first" ||
            tempProject.TYPE_MAKING.CODE === "re-issuance") &&
          tempProject.UF_PROJECT_ID > 0
        ) {
          return true;
        }
      }
      return false;
    },
    setDataTransferProject(tempProject) {
      this.transferProject.id_question = tempProject.ID;
      this.transferProject.id_sovet = null;
      this.transferProject.type_question = tempProject.UF_TYPE_QUESTION;
      this.transferProject.projectId = tempProject.UF_PROJECT_ID;
      this.transferProject.projectNumber =
        "№" + tempProject.PROJECT_UF_NUMBER + " " + tempProject.PROJECT_UF_NAME;
      this.transferProject.comment = "";
      this.transferProject.type_making = null;
      this.transferProject.uf_sort = null;
      this.showDeleteProject = false;
      this.showChangeSovet = true;
    },
    changeTransferProject() {
      if (this.transferProject.id_sovet > 0) {
        this.isViewTransferFormProject = true;
        this.transferProject.uf_sort = null;
      }
    },
    checkIsVisibleDisableTranspher(i) {
      let t = this.experts_projects.LIST_SOVET_ACTUAL.filter(
        c => c.ID === this.transferProject.id_sovet
      );
      return t[0].COUNT_QUESTION >= i ? true : false;
    },
    onSendTransferProject() {
      ExpertAdvice.onSendTransferProject(
        this.transferProject.id_sovet,
        this.transferProject.id_question,
        {
          UF_TYPE_MAKING: this.transferProject.type_making,
          UF_COMMENT: this.transferProject.comment,
          UF_SORT: this.transferProject.uf_sort,
          UF_PROJECT_ID: this.transferProject.projectId
        }
      )
        .then(({ data }) => {
          if (data.error) {
            this.$toasted.show(data.errorArr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            this.fetchProjects();
            this.showEditNewProject = false;
            this.showChangeSovet = false;
          }
        })
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    setEndWorkProject() {
      console.log(this.tempProject);
      ExpertAdvice.onSetEndWorkProject(this.tempProject.ID)
        .then(({ data }) => {
          if (data.error) {
            this.$toasted.show(data.errorArr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            this.fetchProjects();
            this.showEditNewProject = false;
            this.showChangeSovet = false;
            this.showDialogEndWorkProject = false;
          }
        })
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    openDoc(id) {
      ExpertAdvice.getLinkByFileAdvise(id).then(({ data }) => {
        window.open(
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
          "_blank"
        );
      });
    },
    sUploaderFileProtokolQuestion(project, mode) {
      this.showUploaderProtokolQuestionFile = true;
      this.uploadProtokolQuestionBlock = false;
      this.fileProtokolQuestionName =
        mode == "add" ? "Файл не выбран" : "Обновить: файл не выбран";
      this.fileProtokolQuestionName2 = "";
      this.errorArrProtokolQuestion = [];
      this.errorTextProtokolQuestion = "";
      this.itemProtokolTemp = project;
    },
    clearFileProtokolQuestion() {
      this.fileProtokolQuestionName = "Файл не выбран";
      this.fileProtokolQuestionName2 = "";
      this.errorArrProtokolQuestion = [];
      this.errorTextProtokolQuestion = "";
    },
    changeFileProtokolQuestion() {
      const fileInput = this.$refs.fileProtokolQuestion;
      if (!fileInput || !fileInput.files[0]) {
        return;
      }
      const file = fileInput.files[0];
      this.errorTextProtokolQuestion = "";
      if (file.size >= 1024 * 1024 * 100) {
        this.errorTextProtokolQuestion =
          "Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 100 Мб";
        return;
      }
      this.fileProtokolQuestionName2 = file.name;
      this.fileProtokolQuestionName = "    ";
    },
    submitProtokolQuestion() {
      const fileInput = this.$refs.fileProtokolQuestion;
      if (!fileInput || typeof fileInput.files[0] === "undefined") {
        return false;
      }
      this.uploadProtokolQuestionBlock = true;

      const formData = new FormData();
      formData.append("FILE", fileInput.files[0]);

      ExpertAdvice.saveFileProtokolQuestion(
        this.itemProtokolTemp.ID,
        formData
      ).then(response => {
        this.uploadProtokolQuestionBlock = false;
        if (!response.data.error) {
          this.fetchProjects();
          this.showUploaderProtokolQuestionFile = false;
          this.$toasted.show("Файл успешно загружен", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.errorArrProtokolQuestion = response.data.errorArr;
        }
      }, this);
      return false;
    },
    sDeleteFileProtokolQuestionDialog() {
      this.showDialogDeleteFileProtokolQuestion = true;
    },
    deleteFileProtokolQuestion() {
      ExpertAdvice.deleteFileProtokolQuestion(
        this.itemProtokolTemp.ID
      ).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.fetchProjects();
          this.$toasted.show("Файл успешно удален", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
          this.showDialogDeleteFileProtokolQuestion = false;
          this.showUploaderProtokolQuestionFile = false;
        }
      }, this);
    }
  }
};
</script>
